import * as Sentry from "@sentry/react";

// Env-gated. When VITE_SENTRY_DSN is unset (dev / preview), the SDK is a
// no-op and adds zero network overhead.
//
// Session Replay integration was removed because:
//   1. We had replaysSessionSampleRate=0, so it never recorded sessions
//      proactively — only 50% of error sessions, which is a tiny volume
//      for a portfolio site
//   2. The replay SDK initialised on every page load and logged warnings
//      ("Cannot get CSS styles from text's parentNode", "Cannot inline
//      img src=...") which tripped Lighthouse "Browser errors logged to
//      console" Best Practice
//   3. ~50 KB shaved off the initial JS bundle — better mobile perf
// Stack-trace capture via the standard integration is unaffected.
const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    sendDefaultPii: false,
    ignoreErrors: [
      // Browser-extension noise that's not actionable.
      "ResizeObserver loop limit exceeded",
      "Non-Error exception captured",
    ],
  });
}
